export const messages = {
  "PAYMENT.IN.PROGRESS": "Payment already in progress, please retry after 5 minutes",
  "EMAIL.ALREADY.EXISTS": "An account with entered email already exists, please try different email to register, or use login to use existing account",
  "RESEND.OTP.AFTER.1MIN": "Resend otp after one minute",
  "RESEND.OTP.MAX.TRIES.REACHED.TRY.AFTER.30MIN": "Please wait for 30 minutes",
  "OTP.INVALID": "Either code expired or invalid",
  "OLD.PASSWORD.NOMATCH": "Incorrect old password",
  "PASSWORDCONFIRM.NOMATCH": "Confirm password doesn't match",
  "NEW.PASSWORD.SAME.TO.OLD.PASSWORD": "New password should not be same as old password",
  "CANNOT.CHANGE.INSTAGRAM.HANDLE": "Cannot change instagram username",
  "INVALID.IG": "Invalid Instagram username, please change it in account settings",
  "PAYMENT.CANCELLED.RETRY": "Payment cancelled, do you want to retry?",
  "PAYMENT.CANCELLED.RETRY.PASSWORD": "Payment cancelled, do you want to retry? Next time you want to subscribe, please use your handle to login",
  "PAYMENT.CANCELLED": "Payment was cancelled",
  "PAYMENT.SUCCESSFUL": "Payment completed successfully!",
  "PAYMENT.FAILED": "Payment failed. Please try again.",
  "MESSAGE.SENT": "Message sent successfully!",
  "UNLOCKED.MEDIA": "Media unlocked successfully!",
  "NO.VALID.CARD.AVAILABLE": "There are no card(s) saved for this user, redirecting to payment gateway",
  "OFFLINE.PAYMENT.FAILED": "Payment failed using saved card, redirecting to payment gateway",
  "CONTENT.PRICE.INVALID":"Price should be greater than $5",
  "CONTENT.CAN.NOT.DELETED":"Content archived as it is bought by fan so it can be deleted",
  "CARD.ALREADY.ADDED": "Card is already saved",
  "UNARCHIVED.SUCCESSFULLY": "Unarchived successfully",
  "ARCHIVED.SUCCESSFULLY": "Archived successfully",
  "CHOOSE.PLATFORM": "Please choose a platform to create your account"
};
